import {
    BrowserCheckModal,
    ConnectingModal,
    DisconnectedModal,
    InactivityModal
} from '@tassat/modal';
import React from 'react';

import authService from 'Lib/auth/AuthService';
import history from 'Lib/browserHistory';
import {
    ConstantsContext,
    INACTIVITY_WARNING_DURATION,
    LOGOUT_OFFSET_DURATION,
    NO_INTERNET_TIMER_LENGTH
} from 'Lib/constant';
import Worker from 'Lib/worker/PrimusWorker';
import { useAppDispatch, useAppSelector } from 'Reducers/store/hooks';
import { continueUserSession } from 'Reducers/ui';
import {
    getThemeRefreshed, getUiConnected, getUiDisconnected, getUiInactive
} from 'Selectors/common';

import ThemeRefreshModal from '../themeRefreshModal';

export default function AppStateModals() {
    const dispatch = useAppDispatch();
    const connected = useAppSelector(getUiConnected);
    const disconnected = useAppSelector(getUiDisconnected);
    const inactive = useAppSelector(getUiInactive);
    const themeRefreshed = useAppSelector(getThemeRefreshed);
    const noInternetTimer = React.useRef(null);
    const uiConstants = React.useContext(ConstantsContext);
    const warningDuration = React.useMemo(() => Number(uiConstants?.inactivityWarningDuration), [uiConstants?.inactivityWarningDuration]);
    const logoutOffset = React.useMemo(() => Number(uiConstants?.inactivityLogoutOffset), [uiConstants?.inactivityLogoutOffset]);

    React.useEffect(() => {
        window.addEventListener('offline', userOffline);
        window.addEventListener('online', userReconnected);

        return () => {
            window.removeEventListener('offline', userOffline);
            window.removeEventListener('online', userReconnected);
        };
    }, []);

    const userOffline = () => {
        dispatch({ type: 'DisconnectedFromCore' });
        noInternetTimer.current = setTimeout(() => {
            history.push('/offline');
        }, NO_INTERNET_TIMER_LENGTH);
    };

    const userReconnected = () => {
        if (noInternetTimer.current) {
            clearTimeout(noInternetTimer.current);
            dispatch({ type: 'ConnectedToCore' });
        }
    };

    return (
        <>
            <InactivityModal
                inactive={inactive}
                inactivityWarningDuration={!isNaN(warningDuration) &&
                    warningDuration > 0 ?
                    warningDuration
                    : INACTIVITY_WARNING_DURATION}
                logout={() => authService.logout()}
                logoutOffsetDuration={!isNaN(logoutOffset) &&
                    logoutOffset > 0 ?
                    logoutOffset
                    : LOGOUT_OFFSET_DURATION}
                resetInactive={() => {
                    Worker.getInstance()
                        .extendSession();
                    dispatch(continueUserSession());
                }}
            />
            <BrowserCheckModal
                applicationName='Lynq'
                connected={connected}
                logout={() => authService.logout()}
            />
            <DisconnectedModal
                connected={connected}
                disconnected={disconnected}
            />
            <ConnectingModal
                connected={connected}
            />
            <ThemeRefreshModal
                themeRefreshed={themeRefreshed}
            />
        </>
    );
}